import get from 'lodash/get';

function decodeQuestion(item = {}) {
  return {
    id: item.id,
    type: item.type,
    key: item.key,
    label: item.label,
    options: get(item, 'options', []).map(opt => ({
      label: opt.label,
      value: opt.id
    })),
    required: !!item.required
  };
}

export default decodeQuestion;
